import {CommonGroupProps} from '../../type';

export function OnAir({children}: CommonGroupProps) {
  return <div>{children}</div>;
}
